import type { Article } from 'types/subregion';

const getOrderedArticles = (articles: Array<Article>) => {
  const shorttermforecast = articles.find(
    (article) => article?.keywords?.[0] === 'shorttermforecast',
  );
  const longtermforecast = articles.find(
    (article) => article?.keywords?.[0] === 'longtermforecast',
  );
  const seasonalforecast = articles.find(
    (article) => article?.keywords?.[0] === 'seasonalforecast',
  );
  return [shorttermforecast, longtermforecast, seasonalforecast].filter((article) => article);
};

export default getOrderedArticles;
